import React from 'react';

var SvgCrossCircleLg = function SvgCrossCircleLg(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 12c0 4.833 3.918 8.75 8.75 8.75 4.833 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75-8.75 3.918-8.75 8.75m8.75-10c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.391 7.391c.244-.244.64-.244.884 0l4.315 4.315c.244.244.244.64 0 .884s-.64.244-.884 0l-4.315-4.315c-.244-.244-.244-.64 0-.884m5.933 5.933c.244-.244.64-.244.884 0l2.427 2.427c.244.244.244.64 0 .884s-.64.244-.884 0l-2.427-2.427c-.244-.244-.244-.64 0-.884",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.904 7.391c-.244-.244-.64-.244-.884 0l-8.359 8.36c-.244.244-.244.64 0 .884s.64.244.884 0l8.36-8.36c.243-.244.243-.64 0-.884",
    clipRule: "evenodd"
  }));
};
SvgCrossCircleLg.displayName = "CrossCircleLg";

export { SvgCrossCircleLg as S };
